// removed by extract-text-webpack-plugin
module.exports = {"fadeEdges":"_1gvlYyqyL2PiRXAAYMnSZb","padding":"_32gRMGgan3pJf-XvryqQTT"};


//////////////////
// WEBPACK FOOTER
// ./src/components/TimezoneList/index.css
// module id = 688
// module chunks = 0